import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-autodebithistory',
  templateUrl: './autodebithistory.component.html',
  styleUrls: ['./autodebithistory.component.css']
})
export class AutodebithistoryComponent implements OnInit {
  @Input('loan') loan:any;
  constructor() { }

  ngOnInit() {
  }

}
